import { FileUpload } from "common/FileUpload";
import { Input } from "common/InputForm";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React, { useEffect, useState } from "react";
import { addSuveyCategory, deleteSurveyCategory, updateSuveyCategory } from "services/category";
import { toastMessage } from "utils/toastMessage";
import { ValidateInput } from "validation";
import { surveyCategory } from "validation/schema/survey-category";

const AddSurveyCategory = ({
  onClose,
  addCategoryModel,
  surveyCategoryListHandler,
  data
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [inputData, setInputData] = useState({});
  const [error, setError] = useState({});

  // handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  // handle add Survey category close
  const addSurveyCategoryModalClose = () => {
    setInputData({});
    setError({});
    onClose();
  };

  useEffect(() => {
    if (data) {
      setInputData(prev => ({
        ...prev,
        image: { name: data?.image },
        name: data?.name,
        orderNumber: data?.orderNumber
      }))
    }
  }, [addCategoryModel])

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "addCategorySchema",
      surveyCategory,
      null
    );
    setError(errors);
    return status;
  };

  console.log({  inputData:inputData.image?.type  });
  

  // survey delete handler
  const addSurveyCategoryHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoader(true);
      try {
        const formData = new FormData();
        formData.append("name", inputData.name);
        formData.append("orderNumber", inputData.orderNumber);
        if(inputData?.image?.type){
          formData.append("image", inputData.image);
        }

        if (data?._id) {
          formData.append("_id", data._id);
          const { data: responseData, status } = await updateSuveyCategory(formData);
          if (status === 200) {
            surveyCategoryListHandler();
            addSurveyCategoryModalClose();
            toastMessage(responseData.message, "success", "addSurveyCategory");
          }
        } else {
          const { data: responseData, status } = await addSuveyCategory(formData);
          if (status === 201) {
            surveyCategoryListHandler();
            addSurveyCategoryModalClose();
            toastMessage(responseData.message, "success", "addSurveyCategory");
          }
        }
      } catch (e) {
        console.log("error:", e.error);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      <CustomModal
        className={"edit_model"}
        show={addCategoryModel}
        handleClose={addSurveyCategoryModalClose}
      >
        <h3>Add Category</h3>

        <div className="edit_model">
          <div className="form_field">
            <FileUpload
              id={"image"}
              type="file"
              label="Icon*"
              placeholder="Upload Category Icon"
              name="image"
              value={inputData?.image?.name}
              onChange={e => setInputData(prev => ({ ...prev, image: e.target.files[0] }))}
              error={error?.image}
            />
          </div>
          <div className="form_field">
            <Input
              label="Category*"
              placeholder="Enter Survey Category"
              name="name"
              value={inputData?.name || ""}
              onChange={handleInputChange}
              error={error?.name}
            />
          </div>
          <div className="form_field">
            <Input
              label="Order Number*"
              placeholder="Enter Order Number"
              name="orderNumber"
              value={inputData?.orderNumber || ""}
              onChange={handleInputChange}
              error={error?.orderNumber}
            />
          </div>
        </div>
        <div className="button_wrap">
          <button
            type="button"
            className="button light"
            onClick={addSurveyCategoryModalClose}
          >
            Cancel
          </button>

          <button
            type="button"
            ref={buttonLoader}
            onClick={addSurveyCategoryHandler}
            className="button"
          >
            Submit
          </button>
        </div>
      </CustomModal>
    </>
  );
};

export default AddSurveyCategory;
